<template>
  <div class="loading-overlay">
    <img class="overlay-loader" src="../assets/images/iris_spinner.gif" alt="Loading Spinner" />
  </div>
</template>
<script>
export default {
  name: "LoadingOverlay",
};
</script>
<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 1500px;
  z-index: 1;
}

.loading-overlay img {
  display: block;
  position: fixed;
  top: 40%;
  left: 50%;
  height: 100px;
  transform: translate(-50%, -50%);
  transform: -webkit-translate(-50%, -50%);
  transform: -moz-translate(-50%, -50%);
  transform: -ms-translate(-50%, -50%);
}

/* Unlike most browsers, firefox will display alt text while the image is loading instead of only if it failed */
.loading-overlay img:-moz-loading {
  visibility: hidden;
}

.loading-overlay p {
  display: block;
  font-size: 30px;
}
</style>
